import { Button, ButtonsGroup, InputText } from "#/atoms";
import { FC, memo } from "react";
import { ChangePasswordProps } from "./ChangePassword.interface";
import { DESKTOP_SPACING } from "@/theme";
import { Modal } from "#/molecules";


const ChangePassword: FC<ChangePasswordProps> = ({ onChangePassword, onClose }) => {
  let oldPassword = '';
  let newPassword = '';
  let confirmPassword = '';

  return (
    <Modal onClose={onClose} title="Change Password">
      <InputText type="password" label="Old Password" value={oldPassword} onChange={(e) => oldPassword = e.target.value} />
      <InputText type="password" label="New Password" value={newPassword}  onChange={(e) => newPassword = e.target.value} />
      <InputText type="password" label="Confirm New Password" value={confirmPassword} onChange={(e) => confirmPassword = e.target.value} />
      <ButtonsGroup fullWidth margin={`${DESKTOP_SPACING.EL}px 0 0`}>
        <Button onClick={() => onChangePassword(oldPassword, newPassword, confirmPassword)}>Save</Button>
        <Button onClick={onClose}>Cancel</Button>
      </ButtonsGroup>
    </Modal>
  );
}

export default memo(ChangePassword);